import React from "react";

const AppVersionContext = React.createContext({});

export default AppVersionContext;
